import { Component, OnInit, Input } from '@angular/core';

import { ShipmentService } from './shipment.service';
import { ShipmentComponentsService } from './shipment.components.service';

@Component({
   selector: 'app-shipment',
   templateUrl: './shipment.component.html',
   styleUrls: [ './shipment.component.scss' ],
})
export class ShipmentComponent implements OnInit {
   @Input() template = false;

   constructor(
      public shipment: ShipmentService,
      public components: ShipmentComponentsService,
   ) { }

   ngOnInit() {
      this.shipment.template = this.template;
      
      this.shipment.template$.next(this.template);

      this.components.load();
   }

   ngOnDestroy() {
      this.shipment.template$.next(false);
   }
}
